import { useEffect, useState } from "react";  
import { KofiShopGrid } from "tootles-kofi"; 
import { KofiCommissionsList } from "../../commissions/CommissionsTemplate.jsx"; 
import { ErrorViewPlaceholder, LoadingViewPlacholder } from '../../Template.jsx'
import { EditorErrorView, EditorBtn, EditorSection, CenterContainer } from "./EditorTemplate.jsx";


const UpdateSummaryRow = ({ title, data }) => { 
    return <tr><th scope="row">{title}</th><td>{`${data === null ? '--' : data}`}</td></tr> 
}

export function CacheUpdateSummary({ subject, cacheCopy, updatedItems }) {

    const [originalCount, setOriginalCount] = useState(null)
    const [updatedCount, setUpdatedCount] = useState(null)
    
    useEffect(() => {
        setOriginalCount(cacheCopy.length)
    }, [ cacheCopy ])

    useEffect(() => {
        if (updatedItems) {
            setUpdatedCount(updatedItems.length) 
        } 
    }, [ updatedItems ])

    return ( <>
            <h5 className="editor">{`${subject} update summary`}</h5>
            {/*  <pre>{shopItems && JSON.stringify(shopItems)}</pre>
                <pre>{kofiItems && JSON.stringify(kofiItems)}</pre> */}
            <table>
                <tbody>
                    <UpdateSummaryRow title={"original item count"}  data={originalCount} />
                    <UpdateSummaryRow title={"updated item count"}  data={updatedCount} /> 
                </tbody>
            </table>
        </>
    )

}


export function CacheItemsDetailsContainer({ subject, items, children }) {

    const [showItemsInd, setShowItemsInd] = useState(true)
    const [detailsStyle, setDetailsStyle] = useState({ display: 'none' }) 
    
    // const toggleShoeItemsInd = () => setShowItemsInd(!showItemsInd)

    useEffect(() => {
        showItemsInd == true ? setDetailsStyle({ display: 'block' })
            : setDetailsStyle({ display: 'none' })
    }, [showItemsInd])

    if (!items && showItemsInd) {
        return <h5 className="editor">No items to show</h5>
    }
  
    return (<>
        {/* <h5 className="editor">{subject}</h5> */}
        <CenterContainer>
            {showItemsInd ? <EditorBtn action={()=>setShowItemsInd(false)} text={"Hide Items"} />
                : <EditorBtn action={()=>setShowItemsInd(true)} text={"Show Items"} />}
        </CenterContainer>
        <div style={detailsStyle}>
            {children}
        </div>
    </>)
 
}

export function InventoryItemsDetails({ items }) { 
    return <CacheItemsDetailsContainer subject="inventory" items={items}>
         <KofiShopGrid inventory={items} /> 
    </CacheItemsDetailsContainer>
}
export function CommissionItemsDetails({ items }) { 
    return <CacheItemsDetailsContainer subject="commissions" items={items}>
         <KofiCommissionsList items={items} /> 
    </CacheItemsDetailsContainer>
}
 

export function CachedItemsEditor({ subject, cacheCopy, updatedItems, loadStatus, updateStatus, handleUpdate, CacheDataView }) 
{ 
 
    if (loadStatus === 'in_progress') {
        return <LoadingViewPlacholder title={"LOADING CACHED DATA"}/>
    } else if (loadStatus === 'failed') {
        return <ErrorViewPlaceholder 
                    title={"ERROR: FAILED TO LOAD CACHED DATA"} 
                    details={'Let hunty know about it, he will fix <3'}/>
    } else {
        return (
            <div className="editor_tab_container">  
                <EditorSection>
                    {/* <h3 className="editor">{title}</h3> */}
                    <CenterContainer>
                        {updateStatus === 'completed' ? (<p className="center-text">{`update success: copied ${subject} data from kofi`}</p>) : 
                            (<EditorBtn action={handleUpdate} text={`copy latest data from kofi`}/>)}
                    </CenterContainer>
                </EditorSection>
                <EditorSection> 
                    <CacheUpdateSummary 
                        subject={subject}
                        cacheCopy={cacheCopy} 
                        updatedItems={updatedItems} />
                </EditorSection>
                <EditorSection>
                    {updateStatus === 'in_progress' && <p>update in progress...</p>   }
                    {updateStatus === 'failed' && <EditorErrorView err_msg={"FAILED TO COPY UPDATES"} err_details={"You should tell hunty about this. Sometimes the update program turns off by itself. Not sure why o_O"}/>   }
                    {updateStatus === 'completed' ? <CacheDataView items={updatedItems} /> : <CacheDataView items={cacheCopy} /> } 
                </EditorSection>
            </div>
        )
    }
}




 
 